import { aR } from '../global-constants';

export const getNoImageLabels = (labels, inventoryCount) => {
	return {
		title:
			inventoryCount > 0
				? labels.get('NEW_ARRIVAL')
				: labels.get('NO_MATCHING_VEHICLES'),
		subtitle: inventoryCount > 0 ? labels.get('PHOTO_COMING_SOON') : null
	};
};

export const shouldShowDetailsButton = (
	promo,
	incentive,
	aspectRatio,
	enableAppleWallet,
	enablePrint
) => {
	// Only display the button if we have a page fragment to link it to
	// thats what 'url' arg is refering to
	const isIphone =
		navigator.userAgent.includes('iPhone') &&
		navigator.userAgent.includes('AppleWebKit');
	const showAppleWalletBtn = enableAppleWallet === 'true' && isIphone;
	const hasCTA =
		promo.destinationUrl !== undefined &&
		promo.destinationLabel !== undefined;
	const showDetailsBtn =
		promo.additionalDetails !== undefined ||
		promo.disclaimer !== undefined ||
		(incentive !== undefined &&
			incentive !== null &&
			Object.keys(incentive).length !== 0) ||
		(hasCTA && aspectRatio === aR.MOBILE_6X1) ||
		showAppleWalletBtn;

	return (
		(showDetailsBtn || promo.couponCode || enablePrint === 'true') &&
		promo.type &&
		promo.id
	);
};

export const shouldCustomAssetDisclaimerBtnBeOnTop = (aspectRatio) => {
	return (
		aspectRatio === aR.DESKTOP_4X3 ||
		aspectRatio === aR.MOBILE_4X3_SLIDESHOW ||
		aspectRatio === aR.MOBILE_4X3_COUPON ||
		aspectRatio === aR.DESKTOP_4X1
	);
};

// Indicator dots are hidden with `visibility` rather than unmounted so the
// control row keeps its height (US2013029). The skeleton must use the exact
// same predicate as the rendered controls - otherwise dots show during the
// skeleton phase and vanish at handoff (US2079247).
export const getIndicatorDotsVisibility = (showSlideshowIndicatorDots) =>
	showSlideshowIndicatorDots === 'true' ? 'visible' : 'hidden';

export const getPhoneNumber = (phoneList, labels) => {
	let phoneNumbers = [];
	if (!phoneList) return '';
	phoneNumbers = phoneList.map((phoneItem) => {
		return `<div>${labels.get(phoneItem.label)}: ${phoneItem.number}</div>`;
	});
	return phoneNumbers?.join(' ');
};
